import type { UsageProductInput } from '@vy/types';
import { ChargesEditDataGrid } from '../ChargesEditDataGrid';
import { METERED_CREDITS_CHARGES_EDIT_COLUMNS } from './metered-credits-charges-edit-table-const/metered-credits-charges-edit-columns';

type MeteredCreditsChargesEditTableProps = {
  meteredCredits: UsageProductInput[];
};

export const MeteredCreditsChargesEditTable: React.FC<MeteredCreditsChargesEditTableProps> = ({
  meteredCredits,
}) => {
  return (
    <ChargesEditDataGrid
      columns={METERED_CREDITS_CHARGES_EDIT_COLUMNS}
      rows={meteredCredits}
      columnHeaderHeight={40}
      rowHeight={66}
      disableColumnMenu
      disableRowSelectionOnClick
      hideFooter
    />
  );
};
